module.exports = __webpack_public_path__ + "img/brand-cases12.7d2ef1cb.png";